module.exports = __webpack_public_path__ + "static/media/07-Model-1.ac86350b.webp";